// import { Grid, Typography, Box } from "@mui/material";

// export default function Gridview({ gridData }) {
//   return (
//     <Grid container spacing={3}>
//       {gridData.map((data, index) => (
//         <Grid item xs={12} sm={6} md={4} key={index}>
//           {data.type === "img" ? (
//             <Box
//               component="img"
//               src={data.item}
//               alt={`grid-img-${index}`}
//               sx={{ width: "100%", height: "100%", objectFit: "contain" }}
//             />
//           ) : (
//             <Box
//               sx={{
//                 height: "100%",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 textAlign: "center",
//                 p: 5,
//               }}
//             >
//               <Typography
//                 fontFamily="KIAbodyLatinbasic_Bold"
//                 variant="h4"
//                 mb={2}
//                 gutterBottom
//               >
//                 {data.item1}
//               </Typography>
//               <Typography
//                 fontFamily="KIAbodyLatinbasic_Regular"
//                 variant="h5"
//                 mb={2}
//                 gutterBottom
//               >
//                 {data.item2}
//               </Typography>
//               <Typography
//                 fontFamily="KIAbodyLatinbasic_Regular"
//                 variant="body1"
//                 mb={2}
//                 color="text.secondary"
//               >
//                 {data.item3}
//               </Typography>
//             </Box>
//           )}
//         </Grid>
//       ))}
//     </Grid>
//   );
// }






























import React, { useRef, useEffect } from "react";
import { Typography, Box } from "@mui/material";

export default function Gridview({ gridData }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const items = containerRef.current.querySelectorAll(".grid-item");

    const handleScroll = () => {
      items.forEach((item, index) => {
        // Skip animation for the 5th div (index 4)
        if (index === 4) return;

        const rect = item.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (rect.top < windowHeight && rect.bottom > 0) {
          item.style.transform = "translateY(0)";
          item.style.opacity = "1";
        } else {
          item.style.transform = "translateY(50px)";
          item.style.opacity = "0";
        }
      });
    };

    handleScroll(); // run on mount
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "24px",
        width: "100%",
        height: "150vh",
        boxSizing: "border-box",
      }}
    >
      {gridData.map((data, index) => (
        <div
          key={index}
          className="grid-item"
          style={{
            flex: "1 1 100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            // Animate all except 5th
            transform: index === 4 ? "translateY(0)" : "translateY(50px)",
            opacity: index === 4 ? 1 : 0,
            transition: "all 1.00s ease-out",
            ...(window.innerWidth >= 600 && window.innerWidth < 900
              ? { flex: "1 1 calc(50% - 24px)", maxWidth: "calc(50% - 24px)" }
              : {}),
            ...(window.innerWidth >= 900
              ? { flex: "1 1 calc(33.333% - 24px)", maxWidth: "calc(33.333% - 24px)" }
              : {}),
          }}
        >
          {data.type === "img" ? (
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                paddingBottom:
                  index === 4
                    ? "100%" // keep 5th div fixed height
                    : index < 3
                    ? "100%"
                    : "77%",
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                loading="lazy"
                decoding="async"
                src={data.item}
                alt={`grid-img-${index}`}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          ) : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                p: 5,
              }}
            >
              <Typography
                fontFamily="KIAbodyLatinbasic_Bold"
                variant="h5"
                mb={3}
                gutterBottom
              >
                {data.item1}
              </Typography>
              <Typography
                fontFamily="KIAbodyLatinbasic_Regular"
                variant="h5"
                mb={2}
                gutterBottom
              >
                {data.item2}
              </Typography>
              <Typography
                fontFamily="KIAbodyLatinbasic_Regular"
                variant="body1"
                mb={2}
                color="text.secondary"
              >
                {data.item3}
              </Typography>
            </Box>
          )}
        </div>
      ))}
    </div>
  );
}



































































